/** Human-readable customer label for dropdowns: "Nazwa (NIP 123...)" or "NIP 123..." when unnamed. */
export const customerLabel = (c: { companyName?: string | null; nip: string }) =>
  c.companyName ? `${c.companyName} (NIP ${c.nip})` : `NIP ${c.nip}`;
